import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import { TermsAndConditions } from '../components/Terms';


const TermsWa = () => {
    return (
        <>
            <NavBar/>
            <TermsAndConditions />
        </>

    )
}

export default TermsWa;

